import { Link } from "react-router-dom";
import React from "react";

const Footer = () => {
  return (
    <div className="font-jt bg-black opacity-90 py-2 md:py-6 lg:py-8 ">
      <div className="text-white grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-16 px-3 md:px-20 py-2 md:py-6 lg:py-8 bg-grey">
        <div className="space-y-4 lg:px-5 justify-center">
          <h1 className="mb-3 font-semibold text-[14px] lg:text-[18px]  ">
            ABOUT A2Z
          </h1>
          <h1 className=" text-[10px] lg:text-[14px] lg:leading-loose font-light opacity-80">
            a2zRoomz is a company founded to provide experiences to travelers,
            which they can never forget. We want to work towards a painless
            traveling experience within India.
          </h1>
        </div>
        <div className="space-y-4 lg:px-5  justify-center">
          <h1 className="mb-3 font-semibold text-[14px] lg:text-[18px]">
            NAVIGATIONAL LINKS
          </h1>
          <div className="grid grid-cols-2 lg:gap-10">
            <div className="lg:space-y-4 py-1">
              <div>
                <Link
                  to="/"
                  className="anchor-custom lg:my-4 font-extralight text-[10px] lg:text-[15px] opacity-80  "
                >
                  Home
                </Link>
              </div>
              <div>
                <Link
                  to="/"
                  className="lg:my-4 font-extralight text-[10px] lg:text-[15px] opacity-80 "
                >
                  About
                </Link>
              </div>
              <div>
                <Link
                  to="/"
                  className="lg:my-4 font-extralight text-[10px] lg:text-[15px] opacity-80 "
                >
                  Privacy
                </Link>
              </div>
            </div>
            <div className="lg:space-y-4 py-1 justify-center">
              <div>
                <Link
                  to="/"
                  className="lg:my-4 font-extralight text-[10px] lg:text-[15px] opacity-80  "
                >
                  Terms
                </Link>
              </div>
              <div>
                <Link
                  to="/"
                  className="lg:my-4 font-extralight text-[10px] lg:text-[15px] opacity-80 "
                >
                  Refunds
                </Link>
              </div>
              <div>
                <Link
                  to="/"
                  className="lg:my-4 font-extralight text-[10px] lg:text-[15px] opacity-80 "
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4 lg:px-5 justify-center">
          <h1 className="mb-3 font-semibold text-[14px] lg:text-[18px]  ">
            NEWSLETTER
          </h1>
          <h1 className=" text-[10px] lg:text-[15px] leading-loose font-light opacity-80">
            For business professionals caught between high OEM price and
            mediocre print and graphic output.
          </h1>
        </div>
        <div className="lg:space-y-4 px-5 justify-center">
          <h1 className="mb-3 font-semibold text-[14px] lg:text-[18px">
            CONTACT US
          </h1>
          <h1 className=" text-[10px] lg:text-[15px] leading-loose font-light opacity-80">
            a2zRoomz ,310 AKD Tower, Gurgaon, 122001 Haryana, India
          </h1>
          <h1 className=" text-[10px] lg:text-[15px] leading-loose font-light opacity-80">
            +91 894-856-3789
          </h1>
          <h1 className=" text-[10px] lg:text-[15px] leading-loose font-light opacity-80">
            contact@a2zroomz.com
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Footer;
